// extracted by mini-css-extract-plugin
module.exports = {"Extract":"Extract_Extract__2Ays3","item":"Extract_item__3jE38"};